import { Injectable } from '@angular/core';
import { GlobalErrorPayload, GlobalErrorType } from '@models/GlobalErrorPayload';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class GlobalErrorService {
    private errorSubject = new Subject<GlobalErrorPayload>();
    public onError$ = this.errorSubject.asObservable();

    constructor() {}

    emitError(type: GlobalErrorType, status: number, title: string, message: string) {
        this.errorSubject.next({ type, status, title, message });
    }
}
